import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
import { AffiliationTypesState } from '../_reducers/affiliation-type.reducers';
import { AffiliationType } from '../_models/affiliation-type.model';

export const selectAffiliationTypesState =
  createFeatureSelector<AffiliationTypesState>('affiliationTypes');

export const selectAffiliationTypeById = (affiliationTypeId: number) =>
  createSelector(
    selectAffiliationTypesState,
    (affiliationTypesState) => affiliationTypesState.entities[affiliationTypeId],
  );

export const selectAffiliationTypesPageLoading = createSelector(
  selectAffiliationTypesState,
  (affiliationTypesState) => {
    return affiliationTypesState.listLoading;
  },
);

export const selectAffiliationTypesActionLoading = createSelector(
  selectAffiliationTypesState,
  (affiliationTypesState) => affiliationTypesState.actionsloading,
);

export const selectLastCreatedAffiliationTypeId = createSelector(
  selectAffiliationTypesState,
  (affiliationTypesState) => affiliationTypesState.lastCreatedAffiliationTypeId,
);

export const selectAffiliationTypesPageLastQuery = createSelector(
  selectAffiliationTypesState,
  (affiliationTypesState) => affiliationTypesState.lastQuery,
);
export const selectAffiliationTypeErrorState = createSelector(
  selectAffiliationTypesState,
  (affiliationTypesState) => affiliationTypesState.error,
);
export const selectAffiliationTypesInStore = createSelector(
  selectAffiliationTypesState,
  (affiliationTypesState) => {
    const items = (affiliationTypesState.ids as number[])
      .map((id) => affiliationTypesState.entities[id])
      .filter((item): item is AffiliationType => item !== undefined);
    return new QueryResultsModel(items, affiliationTypesState.totalCount);
  },
);
export const selectAffiliationTypesShowInitWaitingMessage = createSelector(
  selectAffiliationTypesState,
  (affiliationTypesState) => affiliationTypesState.showInitWaitingMessage,
);

export const selectHasAffiliationTypesInStore = createSelector(
  selectAffiliationTypesState,
  (queryResult) => {
    if (!queryResult.totalCount) {
      return false;
    }

    return true;
  },
);
